// Firebase Configuration File
// This file sets up and initializes Firebase services used throughout the app
// Firebase provides backend services like authentication, database, file storage, etc.

import { initializeApp } from "firebase/app"; // Firebase app initialization
import { getAuth, connectAuthEmulator, signInWithEmailAndPassword } from "firebase/auth"; // Firebase authentication
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore"; // Firebase Firestore database
import { getDatabase } from "firebase/database"; // Firebase Realtime database
import { getStorage, connectStorageEmulator } from 'firebase/storage'; // Firebase file storage

// Local development against the Firebase emulators (npm run start:emulator).
// The "demo-" project id guarantees nothing can reach the real Firebase project.
const useEmulators = process.env.REACT_APP_USE_EMULATORS === 'true';
const EMULATOR_PROJECT_ID = 'demo-laughub';

// Your web app's Firebase configuration
// These credentials connect your app to the Firebase project
// WARNING: Never share these credentials publicly!
const firebaseConfig = {
  apiKey: "AIzaSyBVNAlPPrksV-T_rKiCn97x8Qma24wHn0E",
  authDomain: "kulinarisklaug.firebaseapp.com",
  projectId: "kulinarisklaug",
  storageBucket: "kulinarisklaug.appspot.com",
  messagingSenderId: "473950854896",
  appId: "1:473950854896:web:0b65a8cb00797a80b92c35",
  measurementId: "G-FB7GX26EBW"
};

console.log("Firebase config: ", firebaseConfig); // Debug: log the config (remove in production)

// Initialize Firebase with the configuration
const app = initializeApp(useEmulators
  ? { ...firebaseConfig, projectId: EMULATOR_PROJECT_ID, storageBucket: `${EMULATOR_PROJECT_ID}.appspot.com` }
  : firebaseConfig);

// Get references to different Firebase services
const auth = getAuth(app); // Authentication service
const firestore = getFirestore(app); // Firestore database service
const database = getDatabase(app); // Realtime database service
const storage = getStorage(app); // File storage service

if (useEmulators) {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
  connectFirestoreEmulator(firestore, '127.0.0.1', 8080);
  connectStorageEmulator(storage, '127.0.0.1', 9199);
  console.info('Firebase: using local emulators (project ' + EMULATOR_PROJECT_ID + ')');

  // Test sign-in without the Google popup, from the browser console.
  // devSignIn('njaal' | 'anders' | 'gil' | 'christian') uses the test accounts from `npm run seed`.
  window.devSignIn = (login) => signInWithEmailAndPassword(auth, `${login}@example.com`, 'emulator');
}

// Export the services so other files can import and use them
export { auth, firestore, database, app, storage  };
export default firestore;